import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { TopShareholderModel } from '../../models/top-shareholder.model';
import { ShareholdersResource } from '../../services/resources/shareholders.resource';

@Component({
    selector: 'sl-top-shareholders',
    templateUrl: './top-shareholders.component.html',
    styleUrls: ['./top-shareholders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopShareholdersComponent implements OnInit {
    top = input(10);

    topShareholders: TopShareholderModel[] = [];
    displayedColumns: string[] = ['id', 'displayName', 'totalShares', 'totalVotingRights', 'lastTransactionDate'];

    private readonly router = inject(Router);
    private readonly shareholderResource = inject(ShareholdersResource);

    ngOnInit(): void {
        this.shareholderResource.getTop(this.top()).subscribe(resp => (this.topShareholders = resp.value));
    }

    goToView(item: TopShareholderModel): void {
        this.router.navigate(['shareholders', item.id]).then();
    }
}
